export const PERMISSIONS = {
  /** Can view advanced configuration vTabs. */
  advancedConfigView: 'advancedconfigurationview',
  /** Can edit advanced configuration settings */
  advancedConfigEdit: 'advancedconfigurationedit',
  /** Can view / edit any JSON configuration textarea. */
  jsonConfigEdit: 'jsonconfigurationedit',
} as const;

export type PermissionCode = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
